import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Print } from "@mui/icons-material";
import { GridRowId, GridRowModel } from "@mui/x-data-grid-pro";
import { GridBulkActionsItem } from "components/DataGrid/components/GridBulkActionsItem";
import { LocationLabelBatchPreview } from "pages/WarehouseLabels/LocationLabelBatchPreview";
import { LocationManagementLocation } from "types/locationManagement/location";

export function codesFromSelectedLocations(selectedRows: Map<GridRowId, GridRowModel>): string[] {
  return Array.from(selectedRows.values())
    .map((row) => (row as LocationManagementLocation).code?.trim() ?? "")
    .filter(Boolean);
}

export function PrintLocationLabelsAction({ onSelect }: { onSelect: (codes: string[]) => void }) {
  return (
    <GridBulkActionsItem
      icon={<Print />}
      label="Print labels"
      onClick={(selectedRows) => {
        const codes = codesFromSelectedLocations(selectedRows);
        if (codes.length) onSelect(codes);
      }}
    />
  );
}

// The bulk-actions menu unmounts as soon as it is clicked, so the preview lives in this dialog.
export function PrintLocationLabelsDialog({ codes, onClose }: { codes: string[] | null; onClose: () => void }) {
  return (
    <Dialog open={codes !== null} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Print location labels</DialogTitle>
      <DialogContent>{codes !== null && <LocationLabelBatchPreview codes={codes} />}</DialogContent>
      <DialogActions>
        <Button type="button" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
